import * as blogsUrls from 'mk2/apps/blogs/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'blogs',
    exact: true,
    path: blogsUrls.blogsArticle,
    getPage: () => {
        return import('mk2/apps/blogs/containers/Article/ArticlePage' /* webpackChunkName: "blogs.Article" */);
    },
    modules: [ 'mk2/apps/blogs/containers/Article/ArticlePage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.blogsMagazineArticle,
    getPage: () => {
        return import('mk2/apps/blogs/containers/Article/ArticlePage' /* webpackChunkName: "blogs.Article" */);
    },
    modules: [ 'mk2/apps/blogs/containers/Article/ArticlePage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroup,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupFeed/GroupFeedPage' /* webpackChunkName: "blogs.GroupFeed" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupFeed/GroupFeedPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsNewGroupExplanation,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupCreateExplanation/GroupCreateExplanationPage' /* webpackChunkName: "blogs.GroupCreateExplanation" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupCreateExplanation/GroupCreateExplanationPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsNewGroupSelect,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupCreateSelect/GroupCreateSelectPage' /* webpackChunkName: "blogs.GroupCreateSelect" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupCreateSelect/GroupCreateSelectPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsNewGroupForm,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupCreate/GroupCreatePage' /* webpackChunkName: "blogs.GroupCreate" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupCreate/GroupCreatePage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsList,
    getPage: () => {
        return import('mk2/apps/blogs/containers/ListOfGroups/ListOfGroupsPage' /* webpackChunkName: "blogs.ListOfGroups" */);
    },
    modules: [ 'mk2/apps/blogs/containers/ListOfGroups/ListOfGroupsPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupInfo,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupInfo/GroupInfoPage' /* webpackChunkName: "blogs.GroupInfo" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupInfo/GroupInfoPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupPhotos,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupPhotos/GroupPhotosPage' /* webpackChunkName: "blogs.GroupPhotos" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupPhotos/GroupPhotosPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupEdit,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupEdit/GroupEditPage' /* webpackChunkName: "blogs.GroupEdit" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupEdit/GroupEditPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupBlockedMembers,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupBlockedMembers/GroupBlockedMembersPage' /* webpackChunkName: "blogs.GroupBlockedMembers" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupBlockedMembers/GroupBlockedMembersPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupInvitedMembers,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupInvitedMembers/GroupInvitedMembersPage' /* webpackChunkName: "blogs.GroupInvitedMembers" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupInvitedMembers/GroupInvitedMembersPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupInvitation,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupInvitation/GroupInvitationPage' /* webpackChunkName: "blogs.GroupInvitation" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupInvitation/GroupInvitationPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupBlockMember,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupBlockMember/GroupBlockMemberPage' /* webpackChunkName: "blogs.GroupBlockMember" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupBlockMember/GroupBlockMemberPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsGroupMembers,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupMembers/GroupMembersPage' /* webpackChunkName: "blogs.GroupMembers" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupMembers/GroupMembersPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsPhotoDetail,
    getPage: () => {
        return import('mk2/apps/blogs/containers/PhotoDetail/PhotoDetailPage' /* webpackChunkName: "blogs.PhotoDetail" */);
    },
    modules: [ 'mk2/apps/blogs/containers/PhotoDetail/PhotoDetailPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsPostDetail,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupPostDetail/GroupPostDetailPage' /* webpackChunkName: "blogs.GroupPostDetail" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupPostDetail/GroupPostDetailPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsUrls.groupsPostEdit,
    getPage: () => {
        return import('mk2/apps/blogs/containers/GroupPostEdit/GroupPostEditPage' /* webpackChunkName: "blogs.GroupPostEdit" */);
    },
    modules: [ 'mk2/apps/blogs/containers/GroupPostEdit/GroupPostEditPage' ],
}];
